import {
  SET_HOURS_ENDORSEMENT_COUNT,
  SET_DISCREPANCIES_COUNT,
  SET_HASNOTPRESENTREPORTS_VALUE,
  SET_NOTIFICATIONS_VALUE,
  SET_SECTIONRELOAD_VALUE,
  SET_PYRO_VISIBLE
} from '../constants/Session';

const initState = {
  tokenValid: false,
  menu_entries_count: {
    hours_endorsement: 0,
    users_discrepancies_list: 0,
    hours_list: 0
  },
  menu_entries_statuses: {
    has_notclosed_reports: false,
  },
  miscellaneous: {
    pyroVisible: false
  },
  sectionReload: "",
  notifications: []
};

const session = (state = initState, action) => {
  switch (action.type) {
    case SET_HOURS_ENDORSEMENT_COUNT:
      return {
        ...state,
        menu_entries_count: {
          ...state.menu_entries_count,
          hours_endorsement: action.count
        }
      };

    case SET_DISCREPANCIES_COUNT:
      return {
        ...state,
        menu_entries_count: {
          ...state.menu_entries_count,
          users_discrepancies_list: action.count
        }
      };
    
    case SET_HASNOTPRESENTREPORTS_VALUE:
      return {
        ...state,
        menu_entries_statuses: {
          ...state.menu_entries_statuses, 
          has_notclosed_reports: action.value,
        },
      };
    
    case SET_NOTIFICATIONS_VALUE:
      return {
        ...state,
        notifications: action.value
      };
    
    case SET_SECTIONRELOAD_VALUE:
      return {
        ...state,
        sectionReload: action.value
      };

    case SET_PYRO_VISIBLE:
      return {
        ...state,
        miscellaneous: {
          ...state.miscellaneous,
          pyroVisible: action.visible
        }
      };
    
    default:
      return state;
  }
};

export default session